import { useSalonManagerContext } from "@admin/components/templates/SalonManager/context"
import Button from "@blocks/Button"
import EmphasizedContent from "@blocks/EmphasizedContent"
import Grid from "@blocks/Grid"
import { confirmation, notify } from "@helpers"
import React from 'react'
import FinishedBestAuthor from './components/BestAuthor/FinishedBestAuthor'
import FinishedFiles from './components/Files'
import FinishedSections from "./components/Sections"
import FinishedDashboardContext from './context'

export default function FinishedDashboard() {
    const { salon } = useSalonManagerContext()
    const finished = salon.api.dashboard.finished.use()

    const sendResults = async () => {
        const confirmed = await confirmation("Are you sure you want to send results to customers?")
        if (!confirmed) return

        await salon.api.notifications.results()
        notify("Sending results to the customers...")
    }

    if (!finished.data) 
        return null

    return (
        <FinishedDashboardContext.Provider value={{ finished } as Admin.Contexts.SalonDashboardFinished}>
            <Grid>
                <FinishedFiles />
                <Grid gap="15px">
                    <Grid gap="0px">
                        <small>Notifications</small>
                        <hr />
                    </Grid>
                    <Grid columns="4">
                        <Grid gap="10px">
                            <h4>Results!</h4>
                            <small>Sends results to salon's participants. Contains report card and a link to the landing.</small>
                            <Button onClick={sendResults} type="tertiary">Notify</Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid gap="15px">
                    <Grid gap="0px">
                        <small>Statistics</small>
                        <hr />
                    </Grid>
                    <Grid gap="20px">
                        <Grid columns="3">
                            <FinishedBestAuthor user={finished.data.best_author} />
                        </Grid>
                        <FinishedSections />
                    </Grid>
                </Grid>
            </Grid>
        </FinishedDashboardContext.Provider>
    )
}